package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.common.api.GoogleFormApi
import io.ktor.http.HttpStatusCode

class SendReportToGoogleFormUseCaseKMP(
    private val googleFormApi: GoogleFormApi,
) {

    suspend operator fun invoke(
        id: String,
        keys: List<String>,
        values: List<String>,
    ): Result<Boolean> =
        runCatching {
            googleFormApi.postData(
                id = id,
                keys = keys,
                values = values,
            )
        }.fold(
            onSuccess = { response ->
                when (response.status) {
                    HttpStatusCode.OK -> Result.success(value = true)
                    HttpStatusCode.NotFound -> Result.success(value = false)
                    else -> Result.failure(exception = IllegalStateException("Unexpected status code: ${response.status}"))
                }
            },
            onFailure = { throwable ->
                Result.failure(exception = throwable)
            },
        )

}
